// extracted by mini-css-extract-plugin
export default {"p":"SUeQ0F9tDj94jEBSeCjV","bold":"ia304ZOYj74evosZdKMH","pink":"HBYt3rBXgPEdp4XMJkQI"};